import styled from "styled-components";
import { appColors } from "../../config/colors";
import { device } from "../../config/sizes";

export const QuoteLayout = styled.div<{ position?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  line-height: 1.3;
  margin: 3rem;

  @media ${device.tablet} {
    padding: 0;
  }

  :before {
    font-family: "Space Mono", Courier, monospace;
    content: "”";
    font-size: 3.5em;
    position: absolute;
    left: -3rem;
    top: -0.5rem;
    line-height: 1em;
  }
`;

export const Text = styled.p`
  font-family: "Space Mono", Courier, monospace;
  font-style: italic;
  font-weight: 100;
  margin-top: 1rem;
  width: 75%;

  @media ${device.tablet} {
    width: 100%;
  }
`;

export const Author = styled.p`
  margin-top: 0.5rem;
  color: ${appColors.fontPrimary};
`;
